import { CHANGE_LOCALE } from '../actionTypes/app.js';

import {
  APP_RESET
} from '../actionTypes/app';

// The initial global state of the App
export const initialState = {
  locale: 'en-US',
};

const global = (state = initialState, action) => {
  switch (action.type) {
    case APP_RESET:
      return initialState;
    case CHANGE_LOCALE:
      return {
        ...state,
        locale: action.payload.locale,
      };
    default:
      return state;
  }
};

export default global;
